import React, { forwardRef, useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'react-jss';
import { createMemoStyles, safeRest, visuallyHidden, defaultFonts, withSpacing, clsx } from '@wds/utils';
import { IconX, IconInfo, IconWarning, IconCheck, IconLock } from '@wds/icons';
import { Slide } from '@wds/motion';

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest();
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$2(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$2(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$6(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$6(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$6(Object(source), true).forEach(function (key) {
        _defineProperty$3(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$6(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var useStyles$3 = createMemoStyles(function (_ref) {
  var spacing = _ref.spacing,
      type = _ref.type;
  return {
    wrenchCloseButton: function wrenchCloseButton(_ref2) {
      var component = _ref2.component;
      var componentSpecificStyles = component === 'badge' ? {
        top: '2px',
        right: spacing[1],
        padding: spacing[1]
      } : {
        right: spacing[1],
        top: spacing[1],
        padding: spacing[2]
      };
      return _objectSpread$6(_objectSpread$6({}, componentSpecificStyles), {}, {
        fontSize: type.fontSize.body,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        position: 'absolute',
        borderRadius: '0',
        textDecoration: 'none',
        background: 'transparent',
        border: 'none',
        '&:hover': {
          transition: 'none',
          textDecoration: 'none'
        },
        '&:active': {
          transition: 'none',
          outline: 'none'
        }
      });
    }
  };
});
var _excluded$7 = ["children", "component", "label", "onClick", "type", "variant"];

var CloseButton = function CloseButton(_ref) {
  _ref.children;
  var component = _ref.component,
      label = _ref.label,
      onClick = _ref.onClick;
  _ref.type;

  var variant = _ref.variant,
      rest = _objectWithoutProperties$2(_ref, _excluded$7);

  var theme = useTheme();

  var _useStyles = useStyles$3({
    theme: theme,
    component: component
  }),
      wrenchCloseButton = _useStyles.wrenchCloseButton;

  return /*#__PURE__*/React.createElement("button", Object.assign({
    onClick: onClick,
    type: "button",
    className: wrenchCloseButton,
    "aria-label": label
  }, safeRest(rest)), /*#__PURE__*/React.createElement(IconX, {
    title: "close",
    color: variant
  }));
};

CloseButton.displayName = "CloseButton";
CloseButton.propTypes = {
  children: PropTypes.string,
  component: PropTypes.string,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  type: PropTypes.string,
  variant: PropTypes.oneOf(['dark', 'light'])
};
CloseButton.defaultProps = {
  children: 'CloseButton',
  component: undefined,
  type: undefined,
  variant: 'light'
};
CloseButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CloseButton",
  "props": {
    "children": {
      "defaultValue": {
        "value": "'CloseButton'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "component": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "type": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "variant": {
      "defaultValue": {
        "value": "'light'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'dark'",
          "computed": false
        }, {
          "value": "'light'",
          "computed": false
        }]
      },
      "required": false,
      "description": ""
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    }
  }
};

function ownKeys$5(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$5(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$5(Object(source), true).forEach(function (key) {
        _defineProperty$3(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$5(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

createMemoStyles(function (theme) {
  var type = theme.type,
      spacing = theme.spacing,
      palette = theme.palette;
  return {
    wrenchLabel: function wrenchLabel(_ref) {
      var muted = _ref.muted,
          plain = _ref.plain;
      return _objectSpread$5(_objectSpread$5({
        display: 'block',
        color: palette.text.dark,
        fontFamily: type.fontFamily.base,
        '-webkit-font-smoothing': 'antialiased',
        boxSizing: 'border-box',
        fontSize: type.fontSize.bodySm,
        padding: 0,
        margin: [0, 0, spacing[1]],
        fontWeight: type.fontWeight.medium
      }, plain && {
        fontWeight: type.fontWeight.regular,
        fontSize: type.fontSize.body
      }), muted && {
        color: palette.text.darkMuted,
        fontWeight: type.fontWeight.regular
      });
    }
  };
});
({
  children: PropTypes.string.isRequired,
  htmlFor: PropTypes.string.isRequired,
  muted: PropTypes.bool,
  plain: PropTypes.bool
});
/* eslint-disable jsx-a11y/no-static-element-interactions */

({
  className: PropTypes.string.isRequired,
  onClick: PropTypes.func
});
var _excluded$6 = ["palette", "spacing"];

function ownKeys$4(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$4(Object(source), true).forEach(function (key) {
        _defineProperty$3(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$4(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

createMemoStyles(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing,
      theme = _objectWithoutProperties$2(_ref, _excluded$6);

  var pane = {
    bgColor: palette.background.accent,
    padding: spacing[5]
  };
  return {
    wrenchPane: function wrenchPane(_ref2) {
      var hide = _ref2.hide,
          transparent = _ref2.transparent;
      return _objectSpread$4(_objectSpread$4(_objectSpread$4({}, hide && visuallyHidden), defaultFonts(theme)), {}, {
        background: transparent ? 'none' : pane.bgColor
      });
    },
    wrenchPaneBody: function wrenchPaneBody() {
      return {
        padding: pane.padding
      };
    }
  };
});
({
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  hide: PropTypes.bool,
  id: PropTypes.string,
  padding: PropTypes.bool,
  labelledBy: PropTypes.string,
  role: PropTypes.string,
  transparent: PropTypes.bool
});

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$1(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$3(Object(source), true).forEach(function (key) {
        _defineProperty$2(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$3(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var useStyles$2 = createMemoStyles({
  wrenchBox: function wrenchBox(_ref) {
    var display = _ref.display,
        flexProperties = _ref.flexProperties;
    var displayProperty = display && {
      display: display
    };
    var flexJustify = flexProperties.flexJustify && {
      justifyContent: flexProperties.flexJustify
    };
    var flexDirection = flexProperties.flexDirection && {
      flexDirection: flexProperties.flexDirection
    };
    var flexAlign = flexProperties.flexAlign && {
      alignItems: flexProperties.flexAlign
    };
    var flexWrap = flexProperties.flexWrap && {
      flexWrap: 'wrap'
    };
    var flexItemGrow = flexProperties.flexItemGrow && {
      flexGrow: 1
    };
    return _objectSpread$3(_objectSpread$3(_objectSpread$3(_objectSpread$3(_objectSpread$3(_objectSpread$3({}, displayProperty), flexJustify), flexDirection), flexAlign), flexWrap), flexItemGrow);
  }
});
var _excluded$5 = ["element", "children", "containerRef", "display", "flexDirection", "flexJustify", "flexAlign", "flexWrap", "flexItemGrow", "spacingClass", "className"];
var displayOptions = Object.freeze(['block', 'inline-block', 'flex', 'inline-flex', 'inline']);
var flexDirectionOptions = Object.freeze(['row', 'column']);
var flexJustifyOptions = Object.freeze(['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly', 'stretch']);
var flexAlignOptions = Object.freeze(['start', 'end', 'center', 'space-between', 'space-around', 'flex-start', 'flex-end', 'stretch', 'baseline']);

var Box = function Box(_ref) {
  var element = _ref.element,
      children = _ref.children,
      containerRef = _ref.containerRef,
      display = _ref.display,
      flexDirection = _ref.flexDirection,
      flexJustify = _ref.flexJustify,
      flexAlign = _ref.flexAlign,
      flexWrap = _ref.flexWrap,
      flexItemGrow = _ref.flexItemGrow,
      spacingClass = _ref.spacingClass,
      className = _ref.className,
      rest = _objectWithoutProperties$1(_ref, _excluded$5);

  var flexProperties = {
    flexDirection: flexDirection,
    flexJustify: flexJustify,
    flexAlign: flexAlign,
    flexWrap: flexWrap,
    flexItemGrow: flexItemGrow
  };
  var theme = useTheme();
  var classes = useStyles$2({
    display: display,
    flexProperties: flexProperties,
    theme: theme
  });
  var Element = element;
  var classNames = clsx(classes.wrenchBox, spacingClass, className);
  return /*#__PURE__*/React.createElement(Element, Object.assign({
    className: classNames,
    ref: containerRef
  }, safeRest(rest)), children);
};

Box.displayName = "Box";
Box.defaultProps = {
  element: 'div',
  containerRef: undefined,
  display: undefined,
  flexDirection: undefined,
  flexJustify: undefined,
  flexAlign: undefined,
  flexWrap: undefined,
  flexItemGrow: undefined,
  spacingClass: undefined,
  className: undefined
};
Box.propTypes = {
  element: PropTypes.string,
  children: PropTypes.node.isRequired,
  containerRef: PropTypes.func,

  /**
   * CSS display property
   */
  display: PropTypes.oneOf(displayOptions),

  /**
   * CSS flex-direction
   */
  flexDirection: PropTypes.oneOf(flexDirectionOptions),

  /**
   * CSS justify-content property
   */
  flexJustify: PropTypes.oneOf(flexJustifyOptions),

  /**
   * CSS align-items property
   */
  flexAlign: PropTypes.oneOf(flexAlignOptions),

  /**
   * Will wrap child items if needed, uses the flex-flow property
   */
  flexWrap: PropTypes.bool,

  /**
   * CSS flex-grow property
   */
  flexItemGrow: PropTypes.bool,

  /**
   * An internal prop that is being used by withSpacing HoC
   */
  spacingClass: PropTypes.string,

  /**
   * To rename the class name of the box
   */
  className: PropTypes.string
};
Box.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Box",
  "props": {
    "element": {
      "defaultValue": {
        "value": "'div'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "containerRef": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "display": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "enum",
        "computed": true,
        "value": "displayOptions"
      },
      "required": false,
      "description": "CSS display property"
    },
    "flexDirection": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "enum",
        "computed": true,
        "value": "flexDirectionOptions"
      },
      "required": false,
      "description": "CSS flex-direction"
    },
    "flexJustify": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "enum",
        "computed": true,
        "value": "flexJustifyOptions"
      },
      "required": false,
      "description": "CSS justify-content property"
    },
    "flexAlign": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "enum",
        "computed": true,
        "value": "flexAlignOptions"
      },
      "required": false,
      "description": "CSS align-items property"
    },
    "flexWrap": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Will wrap child items if needed, uses the flex-flow property"
    },
    "flexItemGrow": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "CSS flex-grow property"
    },
    "spacingClass": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "An internal prop that is being used by withSpacing HoC"
    },
    "className": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "To rename the class name of the box"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    }
  }
};
withSpacing(Box);
Box.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Box",
  "props": {
    "element": {
      "defaultValue": {
        "value": "'div'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "containerRef": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "display": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "enum",
        "computed": true,
        "value": "displayOptions"
      },
      "required": false,
      "description": "CSS display property"
    },
    "flexDirection": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "enum",
        "computed": true,
        "value": "flexDirectionOptions"
      },
      "required": false,
      "description": "CSS flex-direction"
    },
    "flexJustify": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "enum",
        "computed": true,
        "value": "flexJustifyOptions"
      },
      "required": false,
      "description": "CSS justify-content property"
    },
    "flexAlign": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "enum",
        "computed": true,
        "value": "flexAlignOptions"
      },
      "required": false,
      "description": "CSS align-items property"
    },
    "flexWrap": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Will wrap child items if needed, uses the flex-flow property"
    },
    "flexItemGrow": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "CSS flex-grow property"
    },
    "spacingClass": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "An internal prop that is being used by withSpacing HoC"
    },
    "className": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "To rename the class name of the box"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    }
  }
};

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

createMemoStyles(function (theme) {
  var spacing = theme.spacing,
      border = theme.border,
      radius = theme.radius,
      shadow = theme.shadow,
      palette = theme.palette;
  var card = {
    borderRadius: radius.small,
    boxShadow: shadow.none,
    border: border.muted,
    padding: spacing[5],
    bgColor: palette.background.light
  };
  return {
    wrenchCard: function wrenchCard(_ref) {
      var selected = _ref.selected,
          interactive = _ref.interactive;
      return _objectSpread$2(_objectSpread$2(_objectSpread$2({}, defaultFonts(theme)), {}, {
        backgroundColor: card.bgColor,
        border: card.border,
        borderRadius: card.borderRadius,
        boxShadow: card.boxShadow,
        // property will get overwritten, but needed the `cursor: pointer`
        // when interactive
        borderColor: card.borderColor
      }, interactive && {
        '&:hover, &:focus': {
          borderColor: palette.border.hover,
          cursor: 'pointer'
        }
      }), selected && {
        borderColor: palette.border.active,
        '&:hover, &focus': {
          borderColor: palette.border.active
        }
      });
    },
    wrenchCardHeader: function wrenchCardHeader(_ref2) {
      var noRule = _ref2.noRule;
      return _objectSpread$2(_objectSpread$2({}, noRule ? {
        borderBottom: 'none'
      } : {
        borderBottom: border.muted
      }), {}, {
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        margin: '0',
        padding: [spacing[4], spacing[5]],
        minHeight: '72px'
      });
    },
    wrenchCardBody: function wrenchCardBody() {
      return {
        padding: card.padding
      };
    },
    wrenchCardAddon: function wrenchCardAddon() {
      return {
        display: 'inline-flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        minHeight: '40px',
        margin: [0, 0, 'auto', spacing[4]],
        float: 'right'
      };
    }
  };
});
({
  /**
   * Custom right side addon, can be text or components.
   */
  addOn: PropTypes.node,
  children: PropTypes.node.isRequired,

  /**
   * Enable hover styles.
   */
  interactive: PropTypes.bool,

  /**
   * 'Set visibility of divider line.',
   */
  noRule: PropTypes.bool,

  /**
   * Card has built in padding for it&apo;s content but can be turned off.
   */
  padding: PropTypes.bool,

  /**
   * Enable selected card outline.
   */
  selected: PropTypes.bool,

  /**
   * Top section of Card with text title,
   */
  title: PropTypes.node
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

var SEMANTIC_COLORS = Object.freeze(['primary', 'success', 'info', 'warning', 'upgrade', 'secondary', 'muted']);
var TYPE_COLORS = Object.freeze(['dark', 'light', 'darkMuted', 'lightMuted', 'link']);
var SIZES = Object.freeze(['lg', 'md', 'sm']);
Object.freeze(['primary', 'upgrade', 'info', 'success', 'warning', 'secondary']);
Object.freeze([].concat(_toConsumableArray(SIZES), ['xs']));
Object.freeze(['md', 'sm']);
Object.freeze(['success', 'warning']);
Object.freeze(['success', 'warning']);
Object.freeze(['data-one', 'data-two', 'data-three', 'data-four', 'data-five', 'data-six', 'data-seven', 'data-eight', 'data-nine', 'data-ten']);
Object.freeze({
  DOWN: 'ArrowDown',
  END: 'End',
  ESC: 'Escape',
  HOME: 'Home',
  LEFT: 'ArrowLeft',
  PAGE_DOWN: 'PageDown',
  PAGE_UP: 'PageUp',
  RIGHT: 'ArrowRight',
  UP: 'ArrowUp',
  ENTER: 'Enter',
  SPACE: ' ',
  BACKSPACE: 'Backspace',
  TAB: 'Tab'
}); // Deprecated. Moving to e.key

Object.freeze({
  DOWN: 40,
  END: 35,
  ESC: 27,
  HOME: 36,
  LEFT: 37,
  PAGE_DOWN: 34,
  PAGE_UP: 33,
  RIGHT: 39,
  UP: 38,
  ENTER: 13,
  SPACE: 32,
  BACKSPACE: 8,
  TAB: 9
});
Object.freeze({
  37: -1,
  38: -1,
  39: 1,
  40: 1
});
Object.freeze(['top', 'bottom', 'right', 'left']);
Object.freeze(['primary', 'secondary', 'muted', 'success', 'warning', 'upgrade', 'info']);
Object.freeze(['light', 'dark']);
Object.freeze(['primary', 'light', 'dark', 'transparent']);
Object.freeze(['left', 'right', 'even', 'center']);
Object.freeze(['normal', 'near', 'far']);
Object.freeze(['up', 'right', 'down', 'left']);
Object.freeze(['slow', 'normal', 'fast']);
Object.freeze({
  speed: {
    slow: 300,
    normal: 200,
    fast: 100
  }
});
Object.freeze({
  speed: {
    slow: 450,
    normal: 350,
    fast: 250
  },
  distance: {
    normal: 25,
    near: 5,
    far: 75
  }
});
Object.freeze({
  accordion: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=30%3A7&scaling=min-zoom&page-id=30%3A2',
  'action-sheet': 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=30%3A293&scaling=min-zoom&page-id=30%3A288',
  alert: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=30%3A317&scaling=min-zoom&page-id=30%3A312',
  avatar: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=4%3A293&scaling=min-zoom&page-id=4%3A288',
  badge: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=4%3A1243&scaling=min-zoom&page-id=4%3A1238',
  banner: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=30%3A341&scaling=min-zoom&page-id=30%3A336',

  /**
   * TODO: Currently goes to Global Padding, change to box when created
   */
  box: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=30%3A942&scaling=min-zoom&page-id=30%3A937',
  button: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=20%3A9&scaling=min-zoom&page-id=20%3A4',
  'button-group': 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=30%3A389&scaling=min-zoom&page-id=30%3A384',
  card: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=30%3A437&scaling=min-zoom&page-id=30%3A432',
  checkbox: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=4%3A1037&scaling=min-zoom&page-id=4%3A1032',
  coachmark: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=30%3A413&scaling=min-zoom&page-id=30%3A408',
  'form-group': '',
  grid: '',
  icons: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=895%3A13856&scaling=min-zoom&page-id=119%3A2',
  input: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=30%3A485&scaling=min-zoom&page-id=30%3A480',

  /**
   * TODO: This doesn't look like it's up to date right now
   */
  'input-group': 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=30%3A509&scaling=min-zoom&page-id=30%3A504',
  link: '',
  list: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=30%3A893&scaling=min-zoom&page-id=30%3A888',
  menu: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=30%3A533&scaling=min-zoom&page-id=30%3A528',
  modal: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=30%3A557&scaling=min-zoom&page-id=30%3A552',
  motion: '',
  multiselect: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=30%3A581&scaling=min-zoom&page-id=30%3A576',
  'number-picker': 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=30%3A629&scaling=min-zoom&page-id=30%3A624',
  'page-header': 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=30%3A653&scaling=min-zoom&page-id=30%3A648',
  pagination: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=30%3A677&scaling=min-zoom&page-id=30%3A672',
  popout: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=30%3A701&scaling=min-zoom&page-id=30%3A696',
  'progress-bar': 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=4%3A715&scaling=min-zoom&page-id=4%3A710',
  'progress-circle': 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=4%3A715&scaling=min-zoom&page-id=4%3A710',
  radio: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=4%3A1037&scaling=min-zoom&page-id=4%3A1032',

  /**
   * TODO: Doesn't look complete yet, update if necessary
   */
  responsive: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=304%3A1897&scaling=min-zoom&page-id=160%3A17',
  select: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=30%3A725&scaling=min-zoom&page-id=30%3A720',
  'select-menu': 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=30%3A725&scaling=min-zoom&page-id=30%3A720',
  sheet: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=30%3A749&scaling=min-zoom&page-id=30%3A744',
  slider: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=30%3A773&scaling=min-zoom&page-id=30%3A768',
  switch: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=4%3A1037&scaling=min-zoom&page-id=4%3A1032',
  table: '',
  tabs: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=30%3A797&scaling=min-zoom&page-id=30%3A792',
  textarea: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=30%3A821&scaling=min-zoom&page-id=30%3A816',
  toast: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=30%3A845&scaling=min-zoom&page-id=30%3A840',
  tooltip: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=30%3A869&scaling=min-zoom&page-id=30%3A864',
  typography: 'https://www.figma.com/proto/P5WtS8mSjaKYnWVYKnSM67/Design-System-WDS-UI-Kit?node-id=18%3A8&scaling=min-zoom&page-id=18%3A3'
});

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var useStyles$1 = createMemoStyles(function (theme) {
  return {
    wrenchTypography: function wrenchTypography(_ref) {
      var align = _ref.align,
          color = _ref.color,
          variant = _ref.variant;
      var _theme$type = theme.type,
          fontFamily = _theme$type.fontFamily,
          fontSize = _theme$type.fontSize,
          fontWeight = _theme$type.fontWeight,
          palette = theme.palette;
      var chosenColor = palette[color] && palette[color].main || palette.text[color];
      return _objectSpread$1(_objectSpread$1(_objectSpread$1({
        fontFamily: fontFamily.base,
        fontSize: fontSize.body,
        boxSizing: 'border-box',
        '-webkit-font-smoothing': 'antialiased',
        color: chosenColor,
        textAlign: align,
        lineHeight: 1.5,
        margin: 0,
        padding: 0
      }, variant && variant !== 'link' && {
        fontSize: fontSize[variant],
        fontWeight: {
          hero1: fontWeight.light,
          hero2: fontWeight.light,
          title: fontWeight.light,
          sectionTitle: fontWeight.light,
          pageTitle: fontWeight.light,
          cardTitle: fontWeight.medium,
          body: fontWeight.regular,
          bodySm: fontWeight.regular
        }[variant]
      }), variant && variant === 'link' && {
        color: palette.link.main,
        textDecoration: 'none',
        border: 'none',
        background: 'none',
        outline: 'none',
        cursor: 'pointer',
        fontWeight: 'inherit',
        fontSize: 'inherit',
        '&:hover, &:focus': {
          textDecoration: 'underline'
        }
      }), variant && (variant === 'hero1' || variant === 'hero2') && {
        fontFamily: fontFamily.headings
      });
    }
  };
});
var _excluded$4 = ["align", "children", "color", "component", "variant"];
var ALIGNMENT = ['center', 'left', 'right'];
var VARIANTS = ['body', 'bodySm', 'cardTitle', 'hero1', 'hero2', 'link', 'pageTitle', 'sectionTitle']; // @todo: custom components wanted like <Link />??

var COMPONENT_LIST = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'a', 'p', 'span', 'div', 'article', 'section'];
var Typography = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var align = _ref.align,
      children = _ref.children,
      color = _ref.color,
      component = _ref.component,
      variant = _ref.variant,
      rest = _objectWithoutProperties(_ref, _excluded$4);

  var Component = component;
  var theme = useTheme();

  var _useStyles = useStyles$1({
    align: align,
    color: color,
    variant: variant,
    theme: theme
  }),
      wrenchTypography = _useStyles.wrenchTypography;

  return /*#__PURE__*/React.createElement(Component, Object.assign({
    className: wrenchTypography
  }, safeRest(rest), {
    ref: ref
  }), children);
});
Typography.propTypes = {
  /**
   * Align content
   */
  align: PropTypes.oneOf(ALIGNMENT),

  /**
   * Text content to be displayed
   */
  children: PropTypes.node.isRequired,

  /**
   * Color variants
   */
  color: PropTypes.oneOf(SEMANTIC_COLORS.concat(TYPE_COLORS)),

  /**
   * Must be one of the following components:
   */
  component: PropTypes.oneOf(COMPONENT_LIST),

  /**
   * Our variants of choice are:
   */
  variant: PropTypes.oneOf(VARIANTS)
};
Typography.defaultProps = {
  align: 'left',
  component: 'div',
  color: 'dark',
  variant: 'body'
};
Typography.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Typography",
  "props": {
    "align": {
      "defaultValue": {
        "value": "'left'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'center'",
          "computed": false
        }, {
          "value": "'left'",
          "computed": false
        }, {
          "value": "'right'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Align content"
    },
    "component": {
      "defaultValue": {
        "value": "'div'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'h1'",
          "computed": false
        }, {
          "value": "'h2'",
          "computed": false
        }, {
          "value": "'h3'",
          "computed": false
        }, {
          "value": "'h4'",
          "computed": false
        }, {
          "value": "'h5'",
          "computed": false
        }, {
          "value": "'h6'",
          "computed": false
        }, {
          "value": "'a'",
          "computed": false
        }, {
          "value": "'p'",
          "computed": false
        }, {
          "value": "'span'",
          "computed": false
        }, {
          "value": "'div'",
          "computed": false
        }, {
          "value": "'article'",
          "computed": false
        }, {
          "value": "'section'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Must be one of the following components:"
    },
    "color": {
      "defaultValue": {
        "value": "'dark'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "computed": true,
        "value": "SEMANTIC_COLORS.concat(TYPE_COLORS)"
      },
      "required": false,
      "description": "Color variants"
    },
    "variant": {
      "defaultValue": {
        "value": "'body'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'body'",
          "computed": false
        }, {
          "value": "'bodySm'",
          "computed": false
        }, {
          "value": "'cardTitle'",
          "computed": false
        }, {
          "value": "'hero1'",
          "computed": false
        }, {
          "value": "'hero2'",
          "computed": false
        }, {
          "value": "'link'",
          "computed": false
        }, {
          "value": "'pageTitle'",
          "computed": false
        }, {
          "value": "'sectionTitle'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Our variants of choice are:"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": "Text content to be displayed"
    }
  }
};
Typography.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Typography",
  "props": {
    "align": {
      "defaultValue": {
        "value": "'left'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'center'",
          "computed": false
        }, {
          "value": "'left'",
          "computed": false
        }, {
          "value": "'right'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Align content"
    },
    "component": {
      "defaultValue": {
        "value": "'div'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'h1'",
          "computed": false
        }, {
          "value": "'h2'",
          "computed": false
        }, {
          "value": "'h3'",
          "computed": false
        }, {
          "value": "'h4'",
          "computed": false
        }, {
          "value": "'h5'",
          "computed": false
        }, {
          "value": "'h6'",
          "computed": false
        }, {
          "value": "'a'",
          "computed": false
        }, {
          "value": "'p'",
          "computed": false
        }, {
          "value": "'span'",
          "computed": false
        }, {
          "value": "'div'",
          "computed": false
        }, {
          "value": "'article'",
          "computed": false
        }, {
          "value": "'section'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Must be one of the following components:"
    },
    "color": {
      "defaultValue": {
        "value": "'dark'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "computed": true,
        "value": "SEMANTIC_COLORS.concat(TYPE_COLORS)"
      },
      "required": false,
      "description": "Color variants"
    },
    "variant": {
      "defaultValue": {
        "value": "'body'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'body'",
          "computed": false
        }, {
          "value": "'bodySm'",
          "computed": false
        }, {
          "value": "'cardTitle'",
          "computed": false
        }, {
          "value": "'hero1'",
          "computed": false
        }, {
          "value": "'hero2'",
          "computed": false
        }, {
          "value": "'link'",
          "computed": false
        }, {
          "value": "'pageTitle'",
          "computed": false
        }, {
          "value": "'sectionTitle'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Our variants of choice are:"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": "Text content to be displayed"
    }
  }
};
createMemoStyles(function (theme) {
  return {
    wrapper: {
      backgroundColor: theme.palette.background.main,
      padding: theme.spacing[5]
    }
  };
});
({
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  padding: PropTypes.bool,
  children: PropTypes.node
});

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty$3(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var useStyles = createMemoStyles(function (theme) {
  var palette = theme.palette,
      radius = theme.radius,
      shadow = theme.shadow,
      type = theme.type,
      spacing = theme.spacing,
      iconSize = theme.iconSize,
      breakpoints = theme.breakpoints;
  var toast = {
    padding: spacing[5],
    bgColor: palette.background.dark,
    typeColor: palette.text.light,
    borderRadius: radius.small,
    width: 350,
    titleFontSize: type.fontSize.cardTitle,
    bodyTypeSize: type.fontSize.bodySm,
    linkColor: palette.link.contrast,
    boxShadow: shadow.none
  };
  return {
    wrenchToastContainer: function wrenchToastContainer(_ref) {
      var elevation = _ref.elevation;
      return _defineProperty$3({
        position: 'fixed',
        right: spacing[3],
        bottom: spacing[3],
        left: spacing[3],
        zIndex: elevation || theme.elevation.space
      }, "@media (min-width:".concat(breakpoints.sm, "px)"), {
        right: spacing[5],
        bottom: spacing[5],
        width: toast.width,
        left: 'auto'
      });
    },
    wrenchToast: function wrenchToast() {
      return _objectSpread(_objectSpread({}, defaultFonts(theme)), {}, {
        boxSizing: 'border-box',
        margin: 0,
        padding: toast.padding,
        backgroundColor: toast.bgColor,
        color: toast.typeColor,
        borderRadius: toast.borderRadius,
        boxShadow: toast.boxShadow
      });
    },
    wrenchToastIcon: function wrenchToastIcon() {
      return {
        fontSize: iconSize.md,
        marginRight: spacing[3],
        float: 'left'
      };
    },
    wrenchToastTitle: function wrenchToastTitle(color) {
      return {
        color: toast.typeColor,
        fontSize: toast.titleFontSize,
        marginLeft: color && spacing[6]
      };
    },
    wrenchToastBody: function wrenchToastBody(color) {
      return {
        color: toast.typeColor,
        fontSize: toast.bodyTypeSize,
        marginTop: spacing[2],
        marginLeft: color && spacing[6],
        '& > a': {
          color: toast.linkColor,
          textDecoration: 'underline'
        }
      };
    },
    wrenchToastFooter: function wrenchToastFooter(color) {
      return {
        marginTop: spacing[3],
        marginLeft: color && spacing[6],
        '& > *': {
          marginRight: spacing[3]
        }
      };
    }
  };
});
var _excluded$3 = ["children"];

var ToastTitle = function ToastTitle(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties$2(_ref, _excluded$3);

  var theme = useTheme();
  var classes = useStyles({
    theme: theme
  });
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: classes.wrenchToastTitle
  }, rest), children);
};

ToastTitle.displayName = "ToastTitle";
ToastTitle.propTypes = {
  children: PropTypes.node.isRequired
};
ToastTitle.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ToastTitle",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    }
  }
};
var _excluded$2 = ["children"];

var ToastBody = function ToastBody(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties$2(_ref, _excluded$2);

  var theme = useTheme();
  var classes = useStyles({
    theme: theme
  });
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: classes.wrenchToastBody
  }, rest), children);
};

ToastBody.displayName = "ToastBody";
ToastBody.propTypes = {
  children: PropTypes.node.isRequired
};
ToastBody.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ToastBody",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    }
  }
};
var _excluded$1 = ["children"];

var ToastFooter = function ToastFooter(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties$2(_ref, _excluded$1);

  var theme = useTheme();
  var classes = useStyles({
    theme: theme
  });
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: classes.wrenchToastFooter
  }, rest), children);
};

ToastFooter.displayName = "ToastFooter";
ToastFooter.propTypes = {
  children: PropTypes.node.isRequired
};
ToastFooter.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ToastFooter",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    }
  }
};
var _excluded = ["ariaLabel", "onClose", "autoClose", "children", "dismissible", "color", "show", "elevation"];
var TOAST_COLORS = ['info', 'warning', 'upgrade', 'success'];
var TIMEOUT_DELAY = 3000;

var Toast = function Toast(_ref) {
  var ariaLabel = _ref.ariaLabel,
      onClose = _ref.onClose,
      autoClose = _ref.autoClose,
      children = _ref.children,
      dismissible = _ref.dismissible,
      color = _ref.color,
      show = _ref.show,
      elevation = _ref.elevation,
      rest = _objectWithoutProperties$2(_ref, _excluded);

  var timeoutRef = useRef({
    timeout: null
  });

  var _useState = useState(show),
      _useState2 = _slicedToArray(_useState, 2),
      localShow = _useState2[0],
      setLocalShow = _useState2[1];

  var theme = useTheme();
  var classes = useStyles({
    color: color,
    elevation: elevation,
    theme: theme
  });
  var ToastIcon = {
    info: IconInfo,
    warning: IconWarning,
    success: IconCheck,
    upgrade: IconLock
  }[color];

  var handleClose = function handleClose() {
    clearInterval(timeoutRef.current.timeout);
    setLocalShow(false);

    if (onClose) {
      onClose();
    }
  };

  var handleMouseEnter = function handleMouseEnter() {
    if (autoClose) {
      clearInterval(timeoutRef.current.timeout);
    }
  };

  var handleMouseExit = function handleMouseExit() {
    if (autoClose) {
      timeoutRef.current.timeout = setTimeout(function () {
        return handleClose();
      }, TIMEOUT_DELAY);
    }
  };

  useEffect(function () {
    if (autoClose && show) {
      timeoutRef.current.timeout = setTimeout(function () {
        return handleClose();
      }, TIMEOUT_DELAY);
    } else {
      clearInterval(timeoutRef.current.timeout);
    }

    setLocalShow(show);
  }, [show]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrenchToastContainer
  }, /*#__PURE__*/React.createElement(Slide, {
    in: localShow,
    distance: "far"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", Object.assign({
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseExit,
    className: classes.wrenchToast,
    role: "alert"
  }, safeRest(rest)), dismissible ? /*#__PURE__*/React.createElement(CloseButton, {
    onClick: handleClose,
    label: ariaLabel,
    variant: "light"
  }) : null, color ? /*#__PURE__*/React.createElement("div", {
    className: classes.wrenchToastIcon
  }, /*#__PURE__*/React.createElement(ToastIcon, {
    color: color,
    title: "".concat(color, " icon")
  })) : null, children))));
};

Toast.displayName = "Toast";
Toast.propTypes = {
  /**
   * If true, Toast will auto close after 3 seconds
   */
  autoClose: PropTypes.bool,

  /**
   * Toast is composed of 3 subcomponents:
   * Toast.Title,
   * Toast.Body,
   * Toast.Footer
   */
  children: PropTypes.node.isRequired,

  /**
   * If true, an dismissble X icon will appear on the top right
   */
  dismissible: PropTypes.bool,

  /**
   * onClose event handler
   * function(event: object) => void
   */
  onClose: PropTypes.func,

  /**
   * Color variants for Toast
   */
  color: PropTypes.oneOf(TOAST_COLORS),

  /**
   * Specify custom aria label
   */
  ariaLabel: PropTypes.string,

  /**
   * If true, Toast will be visible in view
   */
  show: PropTypes.bool,

  /**
   * If provided, overrides the z-index value of the component
   */
  elevation: PropTypes.number
};
Toast.defaultProps = {
  autoClose: true,
  dismissible: false,
  onClose: undefined,
  color: undefined,
  ariaLabel: 'Close Toast',
  show: true,
  elevation: undefined
};
Toast.Title = ToastTitle;
Toast.Body = ToastBody;
Toast.Footer = ToastFooter;
Toast.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Toast",
  "props": {
    "autoClose": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "If true, Toast will auto close after 3 seconds"
    },
    "dismissible": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "If true, an dismissble X icon will appear on the top right"
    },
    "onClose": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "onClose event handler\nfunction(event: object) => void"
    },
    "color": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'info'",
          "computed": false
        }, {
          "value": "'warning'",
          "computed": false
        }, {
          "value": "'upgrade'",
          "computed": false
        }, {
          "value": "'success'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Color variants for Toast"
    },
    "ariaLabel": {
      "defaultValue": {
        "value": "'Close Toast'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Specify custom aria label"
    },
    "show": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "If true, Toast will be visible in view"
    },
    "elevation": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "If provided, overrides the z-index value of the component"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": "Toast is composed of 3 subcomponents:\nToast.Title,\nToast.Body,\nToast.Footer"
    }
  }
};
export { Toast };